import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/base'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      component: Home,
      redirect: '/nong',
      children: [
        {
          path: '/main',
          component: () => import('@/views/home/home'),
        },
        {
          path: '/works',
          component: () => import('@/views/works/works'),
        },
        {
          path: '/works/details',
          component: () => import('@/views/works/details'),
        },
        {
          path: '/publications',
          component: () => import('@/views/publications/publications'),
        },
        {
          path: '/publications/details',
          component: () => import('@/views/publications/details'),
        },
        {
          path: '/contact',
          component: () => import('@/views/contact/contact'),
        },
        {
          path: '/news',
          component: () => import('@/views/news/news'),
        },
        {
          path: '/about',
          component: () => import('@/views/about/about'),
        }
      ]
    },
    {
      path: '/nong',
      component: () => import('@/views/home/start'),
    },

  ],
})
